import ca from '../locales/ca.json'
import de from '../locales/de.json'
import en from '../locales/en.json'
import es from '../locales/es.json'

export { default as LInput } from './components/Inputs/LInput.vue'
export { default as LButton } from './components/LButton.vue'
export { default as LField } from './components/LField.vue'
export { default as LPhoneInput } from './components/Inputs/LPhoneInput/LPhoneInput.vue'
export { default as LPasswordInput } from './components/Inputs/LPasswordInput.vue'
export { default as LPinInput } from './components/Inputs/LPinInput.vue'
export { default as LCheckbox } from './components/LCheckbox.vue'
export { default as LUpload } from './components/Inputs/LUpload.vue'
export { default as LLoading } from './components/LLoading.vue'
export { default as LPillList } from './components/LPillList.vue'
export { default as LSelect } from './components/Inputs/LSelect.vue'
export { default as LAddressInput } from './components/Inputs/LAddressInput.vue'
export { default as LCard } from './components/LCard.vue'
export { default as NavTab } from './components/navigation/NavTab.vue'
export { default as NavTabTemplate } from './components/navigation/NavTabTemplate.vue'
export { default as LStatus } from './components/LStatus.vue'
export { default as LIcon } from './components/LIcon.vue'
export * from './components/icon.type'
export { default as LCollapse } from './components/LCollapse.vue'
export { default as LRadio } from './components/LRadio.vue'
export { default as LRadioCards } from './components/LRadioCards.vue'
export { default as LEmptyCase } from './components/LEmptyCase.vue'
export { default as LCalendar } from './components/calendar/LCalendar.vue'
export { default as LTimePicker } from './components/calendar/LTimePicker.vue'
export { default as LDatePicker } from './components/calendar/LDatePicker.vue'
export { default as LDropdown } from './components/dropdown/LDropdown.vue'
export { default as LSearchBar } from './components/Inputs/LSearchBar.vue'
export {
  default as LOptionSelector,
  type OptionValue,
  type Option
} from './components/LOptionSelector.vue'
export { default as LSwitch } from './components/LSwitch.vue'
export { default as LTabs } from './components/LTabs.vue'
export { default as LTab } from './components/LTab/LTab.vue'
export { default as LTabList } from './components/LTab/LTabList.vue'
export { default as LBadge } from './components/LBadge.vue'
export { default as LModal } from './components/modal/LModal.vue'
export { default as LColorSelector } from './components/Inputs/LColorSelector.vue'
export { default as LAvatar } from './components/LAvatar.vue'
export { default as LNotification } from './components/Notifications/LNotification.vue'
export { default as LDialog } from './components/LDialog.vue'
export { default as LTooltip } from './components/LTooltip.vue'
export { default as LTable } from './components/LTable/LTable.vue'
export { default as LTableRows } from './components/LTable/LTableRows.vue'
export { default as LTableHeaderRow } from './components/LTable/LTableHeaderRow.vue'
export { default as LTableHeaderCell } from './components/LTable/LTableHeaderCell.vue'
export { default as LTableCell } from './components/LTable/LTableCell.vue'
export { default as LTableBatchEditBar } from './components/LTable/LTableBatchEditBar.vue'
export { default as LPagination } from './components/LPagination/LPagination.vue'
export { default as LDateRangePicker } from './components/calendar/LDateRangePicker.vue'
export { default as LLottie } from './components/LLottie.vue'
export { default as LSteps } from './components/LSteps.vue'
export { default as LCardRadio } from './components/LCardRadio.vue'
export { default as LProgressBar } from './components/LProgressBar.vue'

export { default as LFormField } from './components/forms/LFormField.vue'
export { default as LFormLabel } from './components/forms/LFormLabel.vue'
export { default as LFormError } from './components/forms/LFormError.vue'
export { default as LNumberInput } from './components/Inputs/LNumberInput.vue'
export { default as LTextarea } from './components/Inputs/LTextarea.vue'
export { default as LForm } from './components/forms/LForm.vue'
export { default as LSelectorList } from './components/LSelectorList.vue'
export { default as LSidePanel } from './components/side-panel/LSidePanel.vue'
export * from './components/forms/types'

// Plugins
export * from './plugins/notifications'
export * from './plugins/dialog'
export * from './plugins/events'

// Composables
export * from './composables/useStepsMachine'
export * from './composables/useRecaptcha'

// Types
export * from './components/types'

// Locales
export const locales = {
  en,
  es,
  ca,
  de
}
